export default "__VITE_ASSET__0SsdXHr4__"